    import React from 'react';
    import Card from 'react-bootstrap/Card'
    import CardGroup from 'react-bootstrap/CardGroup'
    import Git_calender from './projects'
    class Home extends React.Component {
        render(){
            return(
                <div>
                    <div className = "row d-flex justify-content-center" style={{width:"100%"}}>
                        <div className = "col-12 col-lg-6 col-md-12 col-sm-12 jumbotron" style = {{backgroundColor:"#0E6E84"}}>
                            <img src = "pic.png" className = "offset-2 pt-2" style = {{borderRadius: "50%", border: "10px solid yellow", height : "150px", backgroundColor:"white"}}></img>
                                <div className = "offset-5">
                                    <h1 style = {{fontFamily: "Open Sans", fontSize: "38px"}} className = "text-light"><b>Anuj Choudhary</b></h1>
                                    <h5 style ={{color:"#F5F5F5"}}><b>Full Stack Developer</b></h5>
                                    <div className = "row mt-3">
                                        <div className="row text-light col-lg-12 ml-1 ">
                                            <h6> Bengaluru, Karnataka, India</h6><br></br>
                                        </div>
                                        <div className="col-lg-12 text-light row ml-1 ">
                                             <h6>7978149515, </h6> <br></br> <a href="mailto:anuj-choudhary@outlook.com" className="ml-2"><h6 className="text-light">anuj-choudhary@outlook.com</h6></a>
                                        </div>
                                    </div>
                                    <h6 className = "mt-3 text-light">A passionate aspiring Full Stack Developer skilled in MERN stack, moulded and shaped by Masai School's numerous training. Actively ready to join in a great 
                                    lively team of a good start-up to adapt me in any situation and environment with ease and perform the best.</h6>
                                </div>
                                
                                <div className = "row mt-5 d-flex justify-content-center">
                                    <div className = "col-1 col-sm-1 col-md-1 col-lg-1 ml-4 ">
                                       <a href ="https://github.com/choudharyanuj"><img src = "https://image.flaticon.com/icons/svg/733/733609.svg" style = {{height: "50px", width:"50px"}}></img></a>
                                    </div>
                                    <div className = "col-1 col-sm-1 col-md-1 col-lg-1 ml-4 ">
                                       <a href = "https://www.linkedin.com/in/anuj-choudhary"><img src = "https://image.flaticon.com/icons/svg/145/145807.svg" style = {{height: "50px", width:"50px"}}></img></a>
                                    </div>
                                    <div className = "col-1 col-sm-1 col-md-1 col-lg-1 ml-4 ">
                                        <a href = "https://twitter.com/anuj_speak"><img src = "https://image.flaticon.com/icons/svg/185/185961.svg" style = {{height: "50px", width:"50px"}}></img></a>
                                    </div>
                                    <div className = "col-1 col-sm-1 col-md-1 col-lg-1 ml-4 ">
                                        <a href = "https://www.hackerrank.com/anuj_choudhary1"><img src = "https://brandfolder.com/hackerrank/logo/hackerrank-primary-logo.png" style = {{height: "50px", width:"50px"}}></img></a>
                                    </div>
                                    <div className = "col-1 col-sm-1 col-md-1 col-lg-1 ml-4 ">
                                        <a href = "mailto:anuj-choudhary@outlook.com"><img src = "https://icon-library.net/images/email-svg-icon/email-svg-icon-5.jpg" style = {{height: "50px", width:"50px"}}></img></a>
                                    </div>
                                    <a href="https://drive.google.com/file/d/1-2usPNOidsp-UNQr4pzY1T9Dssov4A2o/view?usp=sharing" download="Anuj Choudhary.pdf" className="btn btn-warning ml-4 col-3 col-sm-3 col-md-3 col-lg-3">Resume</a>
                                </div>  
                        </div>

                        <div className = "col-lg-6 col-md-12 col-sm-12 jumbotron" style = {{backgroundColor : "#36ADA4" }}>
                            <div className = "row">
                                <div className = "col-lg-4 col-md-4 col-sm-4 d-flex justify-content-center">
                                    <img src = "html.svg" className = "mt-5 ml-2" style = {{height: "110px", width: "110px", borderRadius: "50%" }}></img>
                                </div>
                                <div className = "col-lg-4 col-md-4 col-sm-4 d-flex justify-content-center">
                                    <img src = "css.png" className = "mt-5 ml-2" style = {{height: "110px", width: "110px" }}></img>
                                </div>
                                <div className = "col-lg-4 col-md-4 col-sm-4 d-flex justify-content-center">
                                    <img src = "js.svg" className = "mt-5 ml-2" style = {{height: "110px", width: "110px", borderRadius: "50%" }}></img>
                                </div>
                            </div>
                            <div className = "row">
                                <div className = "col-lg-4 col-md-4 col-sm-4 d-flex justify-content-center">
                                    <img src = "bootstrap.svg" className = "mt-5 ml-2" style = {{height: "110px", width: "110px", borderRadius: "50%" }}></img>
                                </div>
                                <div className = "col-lg-4 col-md-4 col-sm-4 d-flex justify-content-center">
                                    <img src = "react.svg" className = "mt-5 ml-2" style = {{height: "110px", width: "110px" }}></img>
                                </div>
                                <div className = "col-lg-4 col-md-4 col-sm-4 d-flex justify-content-center">
                                    <img src = "redux.png" className = "mt-5 ml-2" style = {{height: "110px", width: "110px", borderRadius: "50%",backgroundColor:"white" }}></img>
                                </div>
                            </div>
                            <div className = "row">
                                <div className = "col-lg-4 col-md-4 col-sm-4 d-flex justify-content-center">
                                    <img src = "python.svg" className = "mt-5 ml-2" style = {{height: "110px", width: "110px"}}></img>
                                </div>
                                <div className = "col-lg-4 col-md-4 col-sm-4 d-flex justify-content-center">
                                    <img src = "git.svg" className = "mt-5 ml-2" style = {{height: "110px", width: "110px"}}></img>
                                </div>
                                <div className = "col-lg-4 col-md-4 col-sm-4 d-flex justify-content-center">
                                    <img src = "flask.svg" className = "mt-5 ml-2" style = {{height: "110px", width: "110px"}}></img>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className = " pl-3 pr-3">
                        <h1 className = "text-center">Proficiencies</h1>
                        <div className = "row text-center">
                            <div className = "col-lg-4 col-md-6 col-sm-12">
                                <img src = "react.svg" style = {{height : "110px", width : "110px", backgroundColor:"#36ADA4", borderRadius:"50%"}}></img>
                                <h3>React App</h3>
                                <p>When it comes to react app <br></br> I have the strength of Atlas</p>
                            </div>
                            <div className = "col-lg-4 col-md-6 col-sm-12">
                                <img src = "canvas.png" style = {{height : "110px", width : "110px"}}></img>
                                <h3>Front End</h3>
                                <p>Now just that I <br></br>can even host the show</p>
                            </div>
                            <div className = "col-lg-4 col-md-12 col-sm-12">
                                <img src = "backend.png" style = {{height : "110px", width : "110px"}}></img>
                                <h3>Backend</h3>
                                <p>I am the one who runs the Show</p>
                            </div>
                        </div>
                    </div>

                    {/* Project Section */}

                    <div className = "jumbotron-fluid pl-3 pr-3 mt-5">
                        <h1 className = "text-center">Projects</h1>

                        {/* Row 1 */}

                        <CardGroup>
                            <div className = "row">
                                <Card className = "col-lg-4 col-md-12 col-sm-12">
                                    <Card.Img variant="top" src="final.png" />
                                    <Card.Body>
                                    <Card.Title className = "text-center"><h2>RAKHT</h2></Card.Title>
                                    <Card.Text>
                                        Designed 1st Complete End to End Frond End Project Using React, Redux and Firebase
                                    </Card.Text>
                                    <div className="d-flex justify-content-center"> 
                                        <img src = "html.svg" className="bg-dark rounded-circle ml-3" style= {{height:"50px", width:"50px"}}></img>
                                        <img src = "css.svg" className="bg-dark rounded-circle ml-3" style= {{height:"50px", width:"50px"}}></img>
                                        <img src = "react.svg" className="bg-dark rounded-circle ml-3" style= {{height:"50px", width:"50px"}}></img>
                                        <img src = "redux.png" className="bg-dark rounded-circle ml-3" style= {{height:"50px", width:"50px"}}></img>
                                        <img src = "canvas.png" className="bg-dark rounded-circle ml-3" style= {{height:"50px", width:"50px"}}></img>
                                        <img src = "backend.png" className="bg-dark rounded-circle ml-3" style= {{height:"50px", width:"50px"}}></img>                                    
                                    </div>
                                    </Card.Body>
                                    <div className="row">
                                        <div className="col-6">
                                            <a href = "https://rakht.netlify.com/" className = "btn btn-outline-danger mb-5 float-right">View Project</a>
                                        </div>
                                        <div className="col-6">
                                            <a href = "https://medium.com/@anujchoudhary108/first-front-end-project-495ff1911cb" className = "btn btn-outline-danger mb-5">View Blog</a>
                                        </div>
                                    </div>
                                </Card>

                                <Card className = "col-lg-4 col-md-12 col-sm-12">
                                    <Card.Img variant="top" src="w9.jpeg" />
                                    <Card.Body>
                                    <Card.Title className = "text-center"><h2>POS</h2></Card.Title>
                                    <Card.Text>
                                        Designed Point On Sale (POS) using React and redux.
                                    </Card.Text>
                                    <div className="d-flex justify-content-center"> 
                                        <img src = "html.svg" className="bg-dark rounded-circle ml-3" style= {{height:"50px", width:"50px"}}></img>
                                        <img src = "css.svg" className="bg-dark rounded-circle ml-3" style= {{height:"50px", width:"50px"}}></img>
                                        <img src = "react.svg" className="bg-dark rounded-circle ml-3" style= {{height:"50px", width:"50px"}}></img>
                                        <img src = "redux.png" className="bg-dark rounded-circle ml-3" style= {{height:"50px", width:"50px"}}></img>
                                    </div>
                                    </Card.Body>
                                    <a href = "https://github.com/choudharyanuj/masai-week-9/tree/master/week_9/pos" className = "btn btn-outline-danger mb-5">View Project</a>
                                </Card> 
                                
                                <Card className = "col-lg-4 col-md-12 col-sm-12">
                                    <Card.Img variant="top" src="w7.png" />
                                    <Card.Body>
                                    <Card.Title className = "text-center"><h2>Microsoft</h2></Card.Title>
                                    <Card.Text>
                                        Designed Landing Page of Microsoft using React.
                                    </Card.Text>
                                    <div className="d-flex justify-content-center"> 
                                        <img src = "html.svg" className="bg-dark rounded-circle ml-3" style= {{height:"50px", width:"50px"}}></img>
                                        <img src = "css.svg" className="bg-dark rounded-circle ml-3" style= {{height:"50px", width:"50px"}}></img>
                                        <img src = "react.svg" className="bg-dark rounded-circle ml-3" style= {{height:"50px", width:"50px"}}></img>
                                    </div>
                                    </Card.Body>
                                    <a href = "https://github.com/choudharyanuj/masai-week-7/tree/master/microsoft" className = "btn btn-outline-danger mb-5">View Project</a>
                                </Card> 

                            </div>
                        </CardGroup>

                        {/* Row 2 */}

                        <CardGroup >
                            <div className = "row">
                                <Card className = "col-lg-4 col-md-12 col-sm-12">
                                    <Card.Img variant="top" src="w6.png" />
                                    <Card.Body>
                                    <Card.Title className = "text-center"><h2>CrickFever</h2></Card.Title>
                                    <Card.Text>
                                        Designed CrickFever using JavaScript and Local Storage. Where you can create your own cricket team and see history
                                    </Card.Text>
                                    <div className="d-flex justify-content-center"> 
                                        <img src = "html.svg" className="bg-dark rounded-circle ml-3" style= {{height:"50px", width:"50px"}}></img>
                                        <img src = "css.svg" className="bg-dark rounded-circle ml-3" style= {{height:"50px", width:"50px"}}></img>
                                        <img src = "js.svg" className="bg-dark rounded-circle ml-3" style= {{height:"50px", width:"50px"}}></img>
                                    </div>
                                    </Card.Body>
                                    <a href = "https://github.com/choudharyanuj/masai-week-6/tree/master/week_6" className = "btn btn-outline-danger mb-5">View Project</a>
                                </Card>   

                                <Card className = "col-lg-4 col-md-12 col-sm-12">
                                    <Card.Img variant="top" src="w5.png" />
                                    <Card.Body>
                                    <Card.Title className = "text-center"><h2>Star War</h2></Card.Title>
                                    <Card.Text>
                                        Designed Star War page using JavaScript, Jquerry and API call (SWAPI)
                                    </Card.Text>
                                    <div className="d-flex justify-content-center"> 
                                        <img src = "html.svg" className="bg-dark rounded-circle ml-3" style= {{height:"50px", width:"50px"}}></img>
                                        <img src = "css.svg" className="bg-dark rounded-circle ml-3" style= {{height:"50px", width:"50px"}}></img>
                                        <img src = "js.svg" className="bg-dark rounded-circle ml-3" style= {{height:"50px", width:"50px"}}></img>
                                    </div>
                                    </Card.Body>
                                    <a href = "https://github.com/choudharyanuj/masai-week-5/tree/master/week_5" className = "btn btn-outline-danger mb-5">View Project</a>
                                </Card> 

                                <Card className = "col-lg-4 col-md-12 col-sm-12">
                                    <Card.Img variant="top" src="w4.png" />
                                    <Card.Body>
                                    <Card.Title className = "text-center"><h2>Stock Manager</h2></Card.Title>
                                    <Card.Text>
                                        Designed Dynamic Stock Manager using JavaScript
                                    </Card.Text>
                                    <div className="d-flex justify-content-center"> 
                                        <img src = "html.svg" className="bg-dark rounded-circle ml-3" style= {{height:"50px", width:"50px"}}></img>
                                        <img src = "css.svg" className="bg-dark rounded-circle ml-3" style= {{height:"50px", width:"50px"}}></img>
                                        <img src = "js.svg" className="bg-dark rounded-circle ml-3" style= {{height:"50px", width:"50px"}}></img>
                                    </div>
                                    </Card.Body>
                                    <a href = "https://github.com/choudharyanuj/masai-week-4/tree/master/week_4" className = "btn btn-outline-danger mb-5">View Project</a>
                                </Card> 

                            </div>                          
                        </CardGroup>

                        {/* Row 3 */}

                        <CardGroup >
                            <div className="row">
                                <Card className = "col-lg-4 col-md-12 col-sm-12">
                                    <Card.Img variant="top" src="w3.png" />
                                    <Card.Body>
                                    <Card.Title className = "text-center"><h2>SUDOKU Game</h2></Card.Title>
                                    <Card.Text>
                                        Designed SUDOKU game using JavaScript
                                    </Card.Text>
                                    <div className="d-flex justify-content-center"> 
                                        <img src = "html.svg" className="bg-dark rounded-circle ml-3" style= {{height:"50px", width:"50px"}}></img>
                                        <img src = "css.svg" className="bg-dark rounded-circle ml-3" style= {{height:"50px", width:"50px"}}></img>
                                        <img src = "js.svg" className="bg-dark rounded-circle ml-3" style= {{height:"50px", width:"50px"}}></img>
                                    </div>
                                    </Card.Body>
                                    <a href = "https://github.com/choudharyanuj/masai-week-3/tree/master/week_3" className = "btn btn-outline-danger mb-5">View Project</a>
                                </Card> 

                                <Card className = "col-lg-4 col-md-12 col-sm-12">
                                    <Card.Img variant="top" src="w2.png" />
                                    <Card.Body>
                                    <Card.Title className = "text-center"><h2>Linux</h2></Card.Title>
                                    <Card.Text>
                                        Designed four pages for Linux using HTML and CSS
                                    </Card.Text>
                                    <div className="d-flex justify-content-center"> 
                                        <img src = "html.svg" className="bg-dark rounded-circle ml-3" style= {{height:"50px", width:"50px"}}></img>
                                        <img src = "css.svg" className="bg-dark rounded-circle ml-3" style= {{height:"50px", width:"50px"}}></img>
                                    </div>
                                    </Card.Body>
                                    <a href = "https://github.com/choudharyanuj/masai-week-2/tree/master/week_2" className = "btn btn-outline-danger mb-5">View Project</a>
                                </Card>  

                                <Card className = "col-lg-4 col-md-12 col-sm-12">
                                    <Card.Img variant="top" src="w1.png" />
                                    <Card.Body>
                                    <Card.Title className = "text-center"><h2>Tom & Jerry</h2></Card.Title>
                                    <Card.Text>
                                        Single page created with HTML and inline CSS only.
                                    </Card.Text>
                                    <div className="d-flex justify-content-center"> 
                                        <img src = "html.svg" className="bg-dark rounded-circle ml-3" style= {{height:"50px", width:"50px"}}></img>
                                        <img src = "css.svg" className="bg-dark rounded-circle ml-3" style= {{height:"50px", width:"50px"}}></img>
                                    </div>
                                    </Card.Body>
                                    <a href = "https://github.com/choudharyanuj/masai-week-1/tree/master/week_1" className = "btn btn-outline-danger mb-5">View Project</a>
                                </Card>                                      
                            </div>                  
                        </CardGroup>
                    </div>

                    <div className = "container-fluid d-flex justify-content-center" style = {{ background: "linear-gradient(#2980b9, #2c3e50)"}}>
                        <div className = "row text-center ">
                            <div className="col-lg-4 col-md-6 col-sm-12 mt-5">
                                <div className="mt-5 offset-2 " style={{width: "250px",height:"250px", background: "#C8F2EE", borderRadius: "50%", border:"20px solid", borderColor: "#06BEB6 #06BEB6 #06BEB6 #06BEB6"}}>
                                    <div className="text-center display-4 font-weight-bold" style = {{marginTop: "80px",fontSize : "50px"}}>
                                        1000+
                                    </div>
                                </div>
                                <div className=" display-4 mt-2 font-weight-bold text-light" style= {{color:"#5D86B4", fontSize : "30px" }}>Hours of Full Stack Coding</div>
                            </div>
                            <div className = "col-lg-4 col-md-6 col-sm-12 mt-5">
                                <div className="mt-5 offset-2 " style={{width: "250px",height:"250px", background: "#C8F2EE", borderRadius: "50%", border:"20px solid", borderColor: "yellow yellow yellow yellow"}}>
                                <div className="text-center display-4 font-weight-bold" style = {{marginTop: "80px",fontSize : "50px"}}>
                                    200+
                                </div>
                                </div>
                                <div className=" display-4 mt-2 font-weight-bold text-light" style= {{color:"#5D86B4", fontSize : "30px" }}>Hackerrank Problem</div>         
                            </div>
                            <div className = 'col-lg-4 col-md-12 col-sm-12 mt-5'>
                                <div className="mt-5 offset-2 offset-md-4" style={{width: "250px",height:"250px", background: "#C8F2EE", borderRadius: "50%", border:"20px solid", borderColor: "green green green green"}}>
                                    <div className="text-center display-4 font-weight-bold" style = {{marginTop: "80px",fontSize : "50px"}}>
                                        400+
                                    </div>
                                </div>
                                <div className="display-4 mt-2 ml-n5 font-weight-bold text-light" style= {{color:"#5D86B4", fontSize : "30px" }}>Git Commits</div>
                            </div>
                        </div>
                </div>
                <center>
                    <div className = "mt-5 text-dark " >
                    {/* <Git_calender/> */}
                    </div>
                </center>
            </div>
            )
        }
    }
    export default Home;


// WEBPACK FOOTER //
// ./src/component/Home.jsx